/* eslint-disable max-len */
import ApplicationStore from '../utils/localStorageUtil';

const successCaseCode = [200, 201];

const _fetchService = (PATH, serviceMethod, data, successCallback, errorCallBack) => {
  const { user_token, userDetails } = ApplicationStore().getStorage('userDetails');
  const END_POINT = 'https://insightsx.in/SahyadriHostel/api/';

  const { emailId, userRole } = userDetails;
  const headers = {
    'Content-Type': 'application/json',
    authorization: `Bearer ${user_token}`,
    userId: `${emailId}`,
    userRole: `${userRole}`,
    branch: `${userDetails.branch}`,
    location: `${userDetails.location}`,
    email: `${userDetails.email}`,
  };

  const body = (serviceMethod === 'GET') || (serviceMethod === 'DELETE') ? {} : { body: JSON.stringify(data) };

  const bodyParameters = {
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    headers,
    ...body,
  };

  return fetch(END_POINT + PATH, { method: serviceMethod, ...bodyParameters })
    .then((response) => {
      if (successCaseCode.includes(response.status)) {
        return response.json().then((res) => successCallback(res));
      }
      return response.json().then((res) => errorCallBack(res));
    })
    .catch((err) => errorCallBack(err));
};

// GET smsWallet/summary  → { data: { total, used, remaining, sentToday, failed, alertThreshold, alertLevel } }
export const GetSmsWalletSummary = (successCallback, errorCallBack) =>
  _fetchService('smsWallet/summary', 'GET', {}, successCallback, errorCallBack);

// GET smsWallet/packages  → { data: [{ id, smsCount, addedOn, addedBy, note }] }
export const GetSmsPackages = (successCallback, errorCallBack) =>
  _fetchService('smsWallet/packages', 'GET', {}, successCallback, errorCallBack);

// POST smsWallet/addPackage  body: { smsCount, note }
export const AddSmsPackage = (data, successCallback, errorCallBack) =>
  _fetchService('smsWallet/addPackage', 'POST', data, successCallback, errorCallBack);

// POST smsWallet/history  body: { date? }  → { total, data: [{ id, studentName, rollNo, parentMobile, message, sentOn, date, status, apiSuccess, apiId }] }
export const GetSmsSentHistory = (data, successCallback, errorCallBack) =>
  _fetchService('smsWallet/history', 'POST', data, successCallback, errorCallBack);

// POST smsWallet/updateThreshold  body: { threshold }
export const UpdateAlertThreshold = (data, successCallback, errorCallBack) =>
  _fetchService('smsWallet/updateThreshold', 'POST', data, successCallback, errorCallBack);

// GET smsWallet/dailyStats  → { data: [{ date, count }] }  (last 30 days)
export const GetSmsDailyStats = (successCallback, errorCallBack) =>
  _fetchService('smsWallet/dailyStats', 'GET', {}, successCallback, errorCallBack);
